import { ReactElement, useEffect } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { useRecoilValue } from 'recoil'
import { accountsState } from '../../states/accounts-state'
import AccountForm from '../../forms/account-form'
import { useFetchAccounts } from '../../hooks/use-fetch-accounts'
import { AccountListItem } from '../../components/accounts-list/account-list-item'

const AccountsScreen = (): ReactElement => {
  const accounts = useRecoilValue(accountsState)
  const fetchData = useFetchAccounts()

  useEffect(() => {
    fetchData().catch(() => {
      console.log('error')
    })
  }, [])

  return (
    <Flexbox flex={1} isCol>
      <ScreenTitle title={'Accounts'} />
      <table className="table table-compact w-full mb-8">
        <thead>
          <tr>
            <th>Name</th>
            <th>Deposits</th>
            {/*<th>Mode</th>*/}
            {/*<th>Fee</th>*/}
            {/*<th>Bank Account</th>*/}
            {/*<th>Opened</th>*/}
            <th>Updated</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {accounts.map((item) => {
            return <AccountListItem id={item.id} />
          })}
        </tbody>
      </table>
      {accounts.length === 0 && <Flexbox className="p-4">No accounts yet.</Flexbox>}
      <AccountForm />
    </Flexbox>
  )
}

export default AccountsScreen